// The strings that must never render (G §22, DS §3.4, the pinned AI epic, the GoToFoods spelling). A phrase entry
// matches anywhere at word edges; a label entry only a whole trimmed text node or accessible name; a regex entry
// (the "My …" possessives) is tested against the whole trimmed node. Case-sensitive throughout.

import { FORBIDDEN, type ForbiddenEntry } from "./glossary.generated";

const COMPILED = FORBIDDEN.map((entry) => ({ entry, pattern: new RegExp(entry.pattern, "u") }));

/** The forbidden entries a text node (or an aria-label, title, alt or placeholder value) hits. */
export function forbiddenHits(text: string): ForbiddenEntry[] {
  const whole = text.replace(/\s+/g, " ").trim();
  return COMPILED.filter(({ entry, pattern }) => pattern.test(entry.mode === "phrase" ? text : whole)).map(({ entry }) => entry);
}
